import _ from 'lodash';

const numEnum = {
  '1':      'one',
  '2':      'two',
  '3':      'three',
  '4':      'four',
  '5':      'five',
  '6':      'six',
  '7':      'seven',
  '8':      'eight',
  '9':      'nine',
  '10':     'ten',
  '11':     'eleven',
  '12':     'twelve',
  '13':     'thirteen',
  '14':     'fourteen',
  '15':     'fifteen',
  '16':     'sixteen',
  one:      'one',
  two:      'two',
  three:    'three',
  four:     'four',
  five:     'five',
  six:      'six',
  seven:    'seven',
  eight:    'eight',
  nine:     'nine',
  ten:      'ten',
  eleven:   'eleven',
  twelve:   'twelve',
  thirteen: 'thirteen',
  fourteen: 'fourteen',
  fifteen:  'fifteen',
  sixteen:  'sixteen',
};

export default numEnum;
